import React from "react";
import SearchableSelectInput from "../../input/searchable-select-input";
import SyncProblemIcon from "@mui/icons-material/SyncProblem";
import { useComponentBackgroundColor } from "../../common/adaptive-theme-provider";
import { Typography } from "@mhome/ui";

const MultiSelectDetail1Widget = ({ widget, onValueUpdate, pattern }) => {
  const getComponentBgColor = useComponentBackgroundColor();

  const handleValueUpdate = (data) => {
    const updatedWidget = { ...widget, value: data };
    onValueUpdate(updatedWidget);
  };

  const disabled = pattern && pattern.endsWith("_R");
  const showWarning = pattern && pattern.endsWith("_W");

  return (
    <div className="w-full flex flex-col">
      {/* Multi Select Controls Section */}
      <div
        className="flex flex-col rounded-2xl p-3"
        style={{
          backgroundColor: getComponentBgColor("hsl(var(--card))"),
        }}
      >
        <Typography className="mb-3 font-bold flex items-center gap-1 text-sm">
          Multi Select
          {showWarning && (
            <SyncProblemIcon
              fontSize="inherit"
              style={{ color: "hsl(var(--warning))" }}
            />
          )}
        </Typography>

        <div className="flex items-center h-full w-full">
          {widget && (
            <SearchableSelectInput
              valueSpec={widget}
              onChange={handleValueUpdate}
              onError={() => {}}
              multiSelect={true}
              style="compact"
              disabled={disabled}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default MultiSelectDetail1Widget;
